
import React, { useState, useEffect } from "react";

const TocTocBeforeAfter = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isShowingAfter, setIsShowingAfter] = useState(false);

  const images = [
    {
      before: "/lovable-uploads/f555df7f-d21d-4dbc-857c-52dbfd2c318a.png",
      after: "/lovable-uploads/a6ce3c5c-4c8f-4acc-a0b6-960bfa789bc1.png"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setIsShowingAfter(prev => !prev);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="container max-w-7xl mx-auto px-4">
        <div className="text-center mb-12 animate-[fadeInUp_0.8s_ease-out_0.2s_both]">
          <h2 className="text-3xl md:text-4xl font-bold text-[#323031] mb-6">
            A diferença que a <span className="text-[#FF5605]">fotografia profissional</span> faz
          </h2>
          <p className="text-xl text-[#5B5A59] max-w-3xl mx-auto">
            Veja como transformamos ambientes comuns em espaços extraordinários
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div id="beforeAfterPhoto" className="relative rounded-2xl overflow-hidden shadow-2xl animate-[scaleIn_0.8s_ease-out_0.4s_both]">
            <div className="relative h-[500px] md:h-[600px]">
              <div 
                className={`absolute inset-0 transition-all duration-1000 ${
                  isShowingAfter ? 'opacity-0 scale-105' : 'opacity-100 scale-100'
                }`}
              >
              <img
                src={images[currentImageIndex].before}
                alt={`Fotografia imobiliária antes do tratamento profissional - Exemplo ${currentImageIndex + 1} de imóvel em Balneário Camboriú`}
                className="w-full h-full object-cover"
                loading="lazy"
                decoding="async"
                width="1200"
                height="800"
              />
                <div className="absolute top-4 left-4 bg-black/70 text-white px-4 py-2 rounded-xl animate-[slideInLeft_0.5s_ease-out]">
                  <span className="text-sm font-medium">ANTES</span>
                </div>
              </div>

              <div 
                className={`absolute inset-0 transition-all duration-1000 ${
                  isShowingAfter ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
                }`}
              >
                <img
                  src={images[currentImageIndex].after}
                  alt={`Fotografia imobiliária após tratamento profissional - Resultado ${currentImageIndex + 1} com edição premium para imóveis SC`}
                  className="w-full h-full object-cover"
                  loading="lazy"
                  decoding="async"
                  width="1200"
                  height="800"
                />
                <div className="absolute top-4 right-4 bg-[#FF5605] text-white px-4 py-2 rounded-xl animate-[slideInRight_0.5s_ease-out]">
                  <span className="text-sm font-medium">DEPOIS</span>
                </div>
              </div>
            </div>

            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2">
              <div className="flex space-x-2">
                <div className={`w-3 h-3 rounded-full transition-all duration-300 ${!isShowingAfter ? 'bg-white scale-125' : 'bg-white/50 scale-100'}`}></div>
                <div className={`w-3 h-3 rounded-full transition-all duration-300 ${isShowingAfter ? 'bg-[#FF5605] scale-125' : 'bg-white/50 scale-100'}`}></div>
              </div>
            </div>
          </div>

          <div className="mt-8 text-center">
            <p className={`text-lg text-[#5B5A59] transition-all duration-500 ${isShowingAfter ? 'animate-[fadeIn_0.5s_ease-out]' : 'animate-[fadeIn_0.5s_ease-out]'}`}>
              {isShowingAfter ? 
                "✨ Com edição profissional: cores vibrantes, iluminação perfeita e destaque para os detalhes" : 
                "📱 Foto original: iluminação inadequada e cores sem vida"
              }
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TocTocBeforeAfter;
